import { ItemType, ScommesseFilterTertiary } from 'components/scommesseFilterTertiary/ScommesseFilterTertiary';

import { ScommesseFiltersContainerPropType } from '.';
import { ScommesseFiltersListSecondary } from 'components/scommesseFiltersListSecondary';
import styles from './PageContent.module.scss';
import { useGetLabelsByKeys } from 'hooks/useLingUI';

export const ScommesseFiltersContainer = ({
  filters,
  itemsSelected,
  filterChecked,
  setFilterChecked,
}: ScommesseFiltersContainerPropType) => {
  const [scommessaFilterBy] = useGetLabelsByKeys(['scommessa-filter-by']);

  return (
    <ScommesseFiltersListSecondary isOpen noRightPadding className={styles.wrapperFilters}>
      <ScommesseFilterTertiary
        defaultChecked={filters![filterChecked]?.value! ?? ''}
        className={styles.wrapperCheckbox}
        title={scommessaFilterBy}
        items={filters ?? []}
        type={ItemType.radio}
        checkedItem={itemsSelected}
        clickAction={(e: HTMLInputElement) => {
          const selectedIndex = filters.findIndex((item) => {
            return item.value === e.value;
          });
          setFilterChecked(selectedIndex);
        }}
      />
    </ScommesseFiltersListSecondary>
  );
};
